import * as Sentry from '@sentry/vue'
import Config from '@/config/Config'
import router from '@/router'
import type { App } from 'vue'

export function setupSentry(app: App) {
  Sentry.init({
    app,
    release: Config.release,
    environment: Config.environment,
    dsn: Config.sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/monnikbestellen\.staging\.brixcloud\.nl/,
      /^https:\/\/www\.monnikbestelportal\.nl/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
